import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-end" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_8 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  key: 1,
  class: "edit-row"
}
const _hoisted_14 = ["colspan"]
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "table table-responsive-md border border-gray" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Relationship to Patient"),
    /*#__PURE__*/_createElementVNode("th", null, "Age of Diagnosis"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1 /* HOISTED */)
const _hoisted_18 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_FamilyHistoryForm = _resolveComponent("FamilyHistoryForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isViewDetailsRequested ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.familyHealthHistory.Condition
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.getRelationship()
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.getAgeOfDiagnosis()
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.getRelationshipStatuses()
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", _hoisted_1, [
        (!_ctx.isEditRequested && !_ctx.isDeleteRequested && !_ctx.isViewDetailsRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_ctx.isEditRequested)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn table-btn btn-outline-info",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditFamilyHistory()))
                  }, _hoisted_4))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn table-btn btn-outline-danger",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDeleteRequest()))
              }, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                class: "btn table-btn btn-outline-info",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openViewDetails()))
              }, " View Details ")
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.currentEditRowId === _ctx.familyHealthHistory.Id)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.isEditRequested)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7, "Edit in Progress"))
                : _createCommentVNode("v-if", true),
              (_ctx.isViewDetailsRequested)
                ? (_openBlock(), _createElementBlock("i", _hoisted_8, "Viewing Details"))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (_ctx.isDeleteRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_TablePrompt, {
                "ok-text": "delete",
                name: "delete",
                "is-in-progress": _ctx.isDeleteInProgress,
                ok: _ctx.deleteFamilyHistory,
                cancel: _ctx.closeDeleteRequest
              }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            _createVNode(_component_FamilyHistoryForm, {
              ref: "editFamilyHistoryForm",
              "is-save-in-progress": _ctx.isEditInProgress,
              "family-health-history": _ctx.cacheFamilyHeathHistory,
              "patient-relationship-enum": _ctx.patientRelationshipEnum,
              "relation-status-enum": _ctx.relationStatusEnum,
              "is-edit": true,
              application: _ctx.application
            }, null, 8 /* PROPS */, ["is-save-in-progress", "family-health-history", "patient-relationship-enum", "relation-status-enum", "application"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-md me-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editFamilyHistory()))
              }, "Save"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary btn-md",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelEditFamilyHistory()))
              }, " Cancel ")
            ])
          ], 8 /* PROPS */, _hoisted_11)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isViewDetailsRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3"
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.familyHealthHistory.PatientRelations, (item) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.PatientRelationship.getKeyUsingValue(item.RelationshipToPatient)), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(item.Age ? item.Age : "N/A"), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(item.Status ? _ctx.RelationStatus.getKeyUsingValue(item.Status) : "N/A"), 1 /* TEXT */)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-md ms-2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeViewDetails()))
              }, " Close ")
            ])
          ], 8 /* PROPS */, _hoisted_14)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}